import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {utilsService} from '../../core/services/utils.service';
import config from 'config';
@observer
export default class AccordionItemHeader extends React.Component {

  static propTypes = {
		isExpanded: PropTypes.bool,
    title: PropTypes.string.isRequired,
    toggleAction: PropTypes.func,
    numberOfItems: PropTypes.number,
    itemArray: PropTypes.array
	}

	static defaultProps = {
		isExpanded: false,
    title: ''
  }

  handleLinkClick = () => {
   // console.log('click on direct link ', this.props.title+' and '+ config[this.props.itemArray[0].href]);
    utilsService.tagLinkItem(this.props.title, 'Direct Link', config[this.props.itemArray[0].href]);
  }
  
  renderLinkHeader() {
    console.log('link', this.props.itemArray);
    
    return(
      <div className="accordion__listItemToggle">
        <a
          target="_self"
          rel="noopener noreferrer"
          href={config[this.props.itemArray[0].href]}
          onClick={this.handleLinkClick}
          className="accordion__listItemToggle__button pointer link-header">
            
          <h2 className="accordion__listItemToggle__title link-header">{this.props.title}
          {/* <div aria-hidden="true" className="external-site-icon"></div> */}
          </h2>
          <span className="sr-only">…Link will open in same browser tab.</span>
        </a>
      </div>
    )
  }

  render() {
    const expandedTextState = this.props.isExpanded ? 'Collapse' : 'Expand';
    
    
    if (this.props.itemArray[0] && this.props.itemArray[0].type === 'DIRECT_LINK') {
      return this.renderLinkHeader();
    } else {
        return(
          <div className="accordion__listItemToggle">
            <button
              type="button"
              className="accordion__listItemToggle__button expandable"

              aria-expanded={this.props.isExpanded}
              onClick={this.props.toggleAction}>
              
              <h2 className="accordion__listItemToggle__title">{this.props.title}</h2>
              <span className="sr-only">{`. ${this.props.numberOfItems} items. click to ${expandedTextState}`}</span>
            </button>
          </div>
        )
    }
  }
}
